module.exports = __webpack_public_path__ + "img/honsu_badge.9569d26a.png";